(() => {
  class ProductDetail extends HTMLElement {
    constructor() {
      super();
    }

    swatchUnsubscriber = undefined;
    variantChangeUnsubscriber = undefined;

    onOptionChange = (event) => {
      const input = event.target;
      const baseUrl = input.dataset.connectedProductUrl;
      if (!baseUrl || input.hasAttribute('data-swatch') || !input.closest('variant-radios')) return;

      event.stopImmediatePropagation();
      input.nextElementSibling.classList.add('loading');
      this.reloadInfo(input.dataset.variantId ? `${baseUrl}?variant=${input.dataset.variantId}` : baseUrl);
    };

    runScripts(el) {
      el.querySelectorAll('script:not([type="application/json"]):not([src])').forEach(oldScript => {
        const newScript = document.createElement('script');
        [...oldScript.attributes].forEach(attr => newScript.setAttribute(attr.name, attr.value));
        newScript.textContent = oldScript.textContent;
        oldScript.replaceWith(newScript);
      });
    }

    reloadInfo(url) {
      fetch(url)
        .then(response => response.text())
        .then(html => {
          const parsed = new DOMParser().parseFromString(html, 'text/html');
          const newInfo = parsed.querySelector(this.infoElSelector);
          const currentInfo = this.querySelector(this.infoElSelector);
          if (!newInfo || !currentInfo) return;

          currentInfo.innerHTML = newInfo.innerHTML;
          this.runScripts(currentInfo);

          const newGallery = parsed.querySelector('[data-pdp-gallery]');
          const currentGallery = this.querySelector('[data-pdp-gallery]');
          if (newGallery && currentGallery) currentGallery.innerHTML = newGallery.innerHTML;

          if (this.isQuickview) this.quickviewEl.update();

          const main = this.closest('main');

          if (!this.isQuickview) {
            main.querySelectorAll(':scope > .shopify-section:not(.shopify-section--product)').forEach(section => {
              const newSection = parsed.getElementById(section.id);
              if (!newSection) return;
              section.innerHTML = newSection.innerHTML;
              this.runScripts(section);
            });
            window.history.pushState({}, '', url);
          }

          requestAnimationFrame(() => {
            window.swipers();
            window.inView();
            if (main && window.okeWidgetApi) {
              main.querySelectorAll('[data-oke-widget], [data-oke-media-grid]').forEach(el => window.okeWidgetApi.initWidget(el));
            }
          });
        })
        .catch(e => console.error(e));
    }

    connectedCallback() {
      this.quickviewEl = this.closest('quick-view');
      this.isQuickview = this.quickviewEl !== null;
      this.pdpEls();
      this.pdpSettings();
      this.pdpListeners();
      this.loadRecsEarly();
      this.setRecentlyViewed();
      this.monitorBwp();

      this.addEventListener('change', this.onOptionChange, true);

      this.swatchUnsubscriber = window.subscribe(PUB_SUB_EVENTS.swatchChange, event => {
        if (event.source !== 'product-detail') return;
        const isQuickviewEvent = event.isQuickview || false;
        this.pdpEl = event.pdpEl || this.pdpEl;
        this.blockEls = this.pdpEl.querySelectorAll(`${this.infoElSelector} [data-block-type]`);
        this.infoEl = this.pdpEl.querySelector(this.infoElSelector);
        this.elsToUpdate = Array.from(this.blockEls).map(el => `[data-block-type="${el.dataset.blockType}"]`);
        this.elsToUpdate.push('[data-pdp-gallery]');
        if (event.el) this.clickedSwatchEl = event.el;
        if (this.pdpEl.querySelector('[data-product-media-zoom-modal]')) this.elsToUpdate.push('[data-product-media-zoom-modal]');
        this.currentVariant = event.currentVariant;
        this.swatchVariants = event.data.variants;
        this.optionValues = event.optionValues;
        this.onChange(event.url, isQuickviewEvent);
      });

      this.variantChangeUnsubscriber = window.subscribe(PUB_SUB_EVENTS.variantChange, event => {
        if (event.sectionId !== this.sectionId && !this.isQuickview) return;
        this.currentVariant = event.currentVariant;
        this.onVariantChange();
      });
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.onOptionChange, true);

      const unsubscribers = [
        this.swatchUnsubscriber,
        this.variantChangeUnsubscriber,
      ];

      unsubscribers.forEach(unsubscriber => unsubscriber && unsubscriber());
    }

    loadRecsEarly() {
      // Instead of waiting for recs to get scrolled into view, start loading when page is idle
      const pdpHasRecs = document.querySelector('product-recommendations');
      const pdpHasRecentlyViewed = document.querySelector('recently-viewed');
      if (!(pdpHasRecs || pdpHasRecentlyViewed) || typeof window.requestIdleCallback !== 'function') return;

      window.requestIdleCallback(deadline => {
        while (deadline.timeRemaining() > 0) {
          lazyLoadScript({
            src: window.assetUrls['product-recommendations.js']
          });
        }
        if (pdpHasRecentlyViewed) {
          lazyLoadScript({
            src: window.assetUrls['recently-viewed.js']
          });
        }
      }, { timeout: 5000 });
    }

    setRecentlyViewed() {
      const handle = this.dataset.productHandle;

      if (localStorage.getItem('product_recently_viewed')) {
        const handles = JSON.parse(localStorage.getItem('product_recently_viewed'));
        const index = handles.indexOf(handle);
        if (index !== -1) {
          handles.splice(index, 1);
          handles.unshift(handle);
        } else {
          handles.push(handle);
        }
        localStorage.setItem('product_recently_viewed', JSON.stringify(handles));
      } else {
        localStorage.setItem('product_recently_viewed', JSON.stringify([handle]));
      }
    }

    monitorBwp() {
      const host = document.querySelector('recharge-subscription-widget');
      if (!host) return;

      const start = () => {
        if (!host.shadowRoot) {
          setTimeout(start, 500);
          return;
        }

        const observer = new MutationObserver(() => this.hideBwp());
        observer.observe(host.shadowRoot, { subtree: true, childList: true, attributes: true });

        host.shadowRoot.addEventListener('change', event => {
          if (event.target.classList?.contains('rc-purchase-option__input')) {
            setTimeout(() => this.hideBwp(), 50);
          }
        });

        setTimeout(() => this.hideBwp(), 1000);
      };

      start();
    }

    hideBwp() {
      const host = document.querySelector('recharge-subscription-widget');
      const bwp = document.querySelector('.bwp-widget-and-separator-container');
      if (!(host && host.shadowRoot && bwp)) return;

      const onetimeBlock = host.shadowRoot.querySelector('.rc-selection__onetime');
      if (!onetimeBlock) return;

      const isOnetimeSelected = !onetimeBlock.hasAttribute('rc-not-selected');
      bwp.classList.toggle('hide', !isOnetimeSelected);
    }

    pdpEls() {
      this.pdpEl = this;
      this.sectionId = this.closest('product-detail').dataset.sectionId;
      this.infoElSelector = '[data-pdp-info]';

      this.blockEls = this.querySelectorAll(`${this.infoElSelector} [data-block-type]`);
      this.infoEl = this.querySelector(this.infoElSelector);
      this.lowStockEl = this.querySelector('[data-low-stock-threshold]');
      this.storePickupEl = this.querySelector('[data-store-pickup-info]');
      this.pageSectionEls = this.closest('main')?.querySelectorAll('.shopify-section');
    }

    pdpSettings() {
      this.elsToUpdate = Array.from(this.blockEls).map(el => `[data-block-type="${el.dataset.blockType}"]`);
      this.elsToUpdate.push('[data-pdp-gallery]');
      if (this.pdpEl.querySelector('[data-product-media-zoom-modal]')) this.elsToUpdate.push('[data-product-media-zoom-modal]');
      this.inventoryData = this.querySelector('[data-json="product-variants-inventory"]') ? JSON.parse(this.querySelector('[data-json="product-variants-inventory"]').textContent) : null;
      this.pageSectionIds = [];
      if (!this.isQuickview) this.pageSectionEls.forEach(section => this.pageSectionIds.push(section.id.split('shopify-section-')[1]));

      const installmentsEl = this.querySelector('#product-form-installment');
      if (installmentsEl) {
        this.productFormInstallment = { el: installmentsEl };
        this.productFormInstallment.id = this.productFormInstallment.el.querySelector('[name="id"]');
        this.productFormInstallment.productId = this.productFormInstallment.el.querySelector('[name="product-id"]');
      }

      /* store page sections in chunks of 5 (sections rendering api limit per call) */
      this.apiSectionLimit = 5;
      this.sectionEls = [];
      this.sectionIds = [];
      document.querySelectorAll('main > .shopify-section:not(.shopify-section--product)').forEach(el => {
        if (!el.classList.contains('shopify-section--yotpo-reviews')) {
          this.sectionEls.push(el);
          this.sectionIds.push(el.id.split('shopify-section-')[1]);
        }
      });
      this.sectionElsChunks = [];
      this.sectionIdsChunks = [];
      while (this.sectionIds.length > 0) {
        this.sectionElsChunks.push(this.sectionEls.splice(0, this.apiSectionLimit));
        this.sectionIdsChunks.push(this.sectionIds.splice(0, this.apiSectionLimit));
      }
    }

    pdpListeners() {
      if (this.isQuickview) return;

      const onHistoryChange = () => {
        const updateActiveSwatch = true;
        this.updateContent({ url: location.href, updateActiveSwatch, isQuickview: false });
      };

      window.addEventListener('popstate', onHistoryChange);
    }

    onChange(url, isQuickviewEvent = false) {
      const notQuickview = !this.isQuickview && !isQuickviewEvent;

      this.updateContent({ url, updateActiveSwatch: true, isQuickview: !notQuickview });
    }

    onVariantChange() {
      window.publish(PUB_SUB_EVENTS.stickyFormUpdate, {
        currentVariant: this.currentVariant,
      });

      const params = new URLSearchParams(window.location.search);

      params.set('variant', this.currentVariant.id);

      const url = `${window.location.pathname}?${params.toString()}`;
      this.updateUrl(url)

      if (this.lowStockEl) {
        const inventory = this.inventoryData[this.currentVariant.id];
        const lowStockThreshold = parseInt(this.lowStockEl.dataset.lowStockThreshold);
        if (!lowStockThreshold) return;

        if (inventory > lowStockThreshold || inventory === 0 || !this.currentVariant || this.currentVariant.available === false) {
          this.lowStockEl.classList.add('hide');
        } else {
          this.lowStockEl.classList.remove('hide');
        }
      }

      if (this.storePickupEl) {
        this.updateStorePickup()
      }
    }

    updateActiveSwatch(url) {
      const activeSwatchEl = this.infoEl.querySelector(`.product-swatches__item--active`);
      if (activeSwatchEl) activeSwatchEl.classList.remove('product-swatches__item--active');
      const newActiveSwatchEl = this.infoEl.querySelector(`[data-swatch-item="${url.split('/products/')[1].split('?')[0]}"]`);
      newActiveSwatchEl && newActiveSwatchEl.classList.add('product-swatches__item--active');
    }

    updateStorePickup() {
      fetch(`${Shopify.routes.root}products/${this.dataset.productHandle}?variant=${this.currentVariant.id}&section_id=product-pickup-availability`)
        .then(response => response.text())
        .then(responseText => {
          const parsedHtml = new DOMParser().parseFromString(responseText, 'text/html');
          const newPickupInfoEl = parsedHtml.querySelector('[data-store-pickup-info]');
          const currentPickupInfoEl = this.querySelector('[data-store-pickup-info]');
          if (newPickupInfoEl && currentPickupInfoEl) {
            currentPickupInfoEl.innerHTML = newPickupInfoEl.innerHTML;
          }
        })
        .catch(e => console.error(e));
    }

    updateContent({ url, updateActiveSwatch = false, isQuickview = false }) {
      const urlSplit = url.split('?');
      const params = new URLSearchParams(urlSplit[1]);
      params.set('section_id', this.sectionId);
      if (this.optionValues) params.set('option_values', this.optionValues.join(','));
      fetch(`${urlSplit[0]}?${params.toString()}`)
        .then(response => response.text())
        .then(responseText => {
          this.updateDetails(responseText);
          if (!isQuickview) this.updateUrl(url);
          if (updateActiveSwatch) this.updateActiveSwatch(url);
          this.clickedSwatchEl?.classList.remove('loading');

          requestAnimationFrame(() => {
            if (!isQuickview) this.updateMainSections(url);

            this.updateBuyForm(responseText);

            if (!this.swatchVariants) return;
            const selectedEl = this.pdpEl.querySelector('variant-radios input:checked') || this.querySelector('variant-radios input:checked');
            const selectedV = this.swatchVariants.find(v => v.title === selectedEl.value);
            if (selectedV) {
              this.currentVariant = selectedV;
              const variantRadios = this.querySelector('variant-radios');
              if (variantRadios) {
                variantRadios.variantData = null;
                variantRadios.dispatchEvent(new Event('change'));
              }
            }
          });
        })
        .catch((e) => {
          console.error(e);
        });
    }

    updateDetails(html) {
      this.elsToUpdate.forEach(selector => {
        const el = this.pdpEl.querySelector(selector) || this.querySelector(selector);
        const parsedHtml = new DOMParser().parseFromString(html, 'text/html');
        const parsedEl = parsedHtml.querySelector(selector);
        if (!(el && parsedEl)) return;
        el.innerHTML = parsedEl.innerHTML;
      })

      this.quickviewEl = this.pdpEl.closest('quick-view');
      requestAnimationFrame(() => {
        this.quickviewEl?.update();
        window.swipers();
        window.inView();
      });
    }

    renderMainSections(sectionsHtml, url, chunkIndex) {
      this.sectionElsChunks[chunkIndex].forEach((section, index) => {
        const id = this.sectionIdsChunks[chunkIndex][index];
        const div = document.createElement('div');
        const sectionHtml = sectionsHtml[id];
        if (!sectionHtml) return;

        /* updat section's html */
        div.innerHTML = sectionsHtml[id];
        const html = div.querySelector(`#shopify-section-${id}`).innerHTML;
        if (id === 'sticky-form') {
          if (section.querySelector('sticky-form') && div.querySelector(`sticky-form`)) {
            section.querySelector('sticky-form').innerHTML = div.querySelector(`sticky-form`).innerHTML;
            setTimeout(() => {
              window.publish(PUB_SUB_EVENTS.stickyFormStart, {});
            }, 500);
          }
        } else {
          section.innerHTML = html;
        }

        /* update page title */
        if (index > 0) return;
        const pageTitle = div.querySelector('[data-meta-title]');
        if (pageTitle) document.title = pageTitle.dataset.metaTitle;
      });

      window.swiperLoaded = false;
      requestAnimationFrame(() => {
        window.swipers();
        window.inView();
      });
    }

    updateMainSections(url) {
      if (this.isQuickview) return;

      const urlSplit = url.split('?');
      const params = new URLSearchParams(urlSplit[1]);
      if (this.optionValues) params.set('option_values', this.optionValues.join(','));

      this.sectionIdsChunks.forEach((ids, index) => {
        params.append('sections', ids.join(','));

        fetch(`${urlSplit[0]}?${params.toString().replaceAll('%2C', ',')}`).then((response) => {
          /* make sure the page loads without js in case of any errors (429, etc...) */
          if (!response.ok) {
            window.location = url;
            return null;
          }
          return response.text();
        }).then(response => {
          if (!response) return;
          this.renderMainSections(JSON.parse(response), url, index);
        });
      });
    }

    updateUrl(url) {
      if (this.isQuickview) return;

      const urlSplit = url.split('?');
      const params = new URLSearchParams(urlSplit[1]);
      const vId = this.currentVariant ? this.currentVariant.id : this.querySelector('[name="id"]').value;
      if (vId) params.set('variant', vId);
      url = `${urlSplit[0]}?${params.toString()}`;
      window.history.pushState({}, '', url)
    }

    updateBuyForm(html) {
      if (!html) {
        console.error('Unable to update product form');
        return;
      }

      // Fetched product data
      const parsedHtml = new DOMParser().parseFromString(html, 'text/html');
      const parsedForm = parsedHtml.querySelector('product-form');
      const parsedFormInputEl = parsedForm.querySelector(`#product-form-${this.dataset.sectionId} input[name="id"]`);
      const parsedAtcBtn = parsedForm.querySelector('.pdp__submit');
      const parsedBisBtn = parsedForm.querySelector('.product__bis');

      // Existing DOM els
      const productForm = this.querySelector('product-form');
      const formInputEl = this.querySelector(`#product-form-${this.dataset.sectionId} input[name="id"]`);
      const atcBtn = this.querySelector('.pdp__submit');
      const bisBtn = this.querySelector('.product__bis');

      // Update hidden form input with variant ID
      const id = parsedFormInputEl?.value || null;
      if (formInputEl) formInputEl.value = id;

      // Update ATC and BIS buttons
      if (atcBtn && parsedAtcBtn) atcBtn.replaceWith(parsedAtcBtn);
      if (bisBtn && parsedBisBtn) bisBtn.replaceWith(parsedBisBtn);

      if (!parsedForm.classList.contains('bis-active')) {
        bisBtn?.classList.add('hide');
      } else {
        productForm?.classList.add('bis-active');
      }

      // Update product info in BIS modal
      const parsedBisProductInfo = parsedHtml.querySelector('[data-bis-product-info]');
      const bisProductInfoEl = this.querySelector('[data-bis-product-info]');
      if (parsedBisProductInfo && bisProductInfoEl) bisProductInfoEl.innerHTML = parsedBisProductInfo.innerHTML;
    }
  }

  if (document.documentElement.dataset.templateName.includes('product')) {
    document.addEventListener('DOMContentLoaded', () => {
      if (!customElements.get('product-detail')) {
        customElements.define('product-detail', ProductDetail);
      }
    });
  } else {
    if (!customElements.get('product-detail')) {
      customElements.define('product-detail', ProductDetail);
    }
  }
})();
